import React, { useContext } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { css } from '@emotion/react';
import { Grid } from '@material-ui/core';
import { SectionTitle, ModalContent, ResponsiveSidebarDialog } from '@/styles/blocks';
import CSVDropzone from '@/components/CSVDropzone';
import { Context } from '../store';
import { MODALS } from '../constants';

const JSONUploadModal = () => {
    const { state, callbacks } = useContext(Context);

    const open = state.current === MODALS.JSON_UPLOAD;

    const onUpload = (file) => {
        if (file.type !== 'application/json' && !file.name.toLowerCase().endsWith('.json')) {
            callbacks.setErrorMsg('Incorrect file type (expected .json)');
            return;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
            const content = event.target.result;
            try {
                JSON.parse(content);
                callbacks.setUploadedFile({ data: content, name: file.name });
                callbacks.advance();
            } catch (err) {
                console.error(err);
                callbacks.setErrorMsg('Invalid JSON: upload a valid JSON file');
            }
        };

        reader.onerror = () => {
            callbacks.setErrorMsg('Error reading .json file');
        };

        reader.readAsText(file);
    };

    return (
        <ResponsiveSidebarDialog open={open} onClose={callbacks.reset}>
            <ModalContent width={740}>
                <Grid
                    css={css`
                        display: flex;
                        justify-content: space-between;
                    `}
                >
                    <SectionTitle>Upload JSON</SectionTitle>
                    <CloseIcon
                        css={css`
                            cursor: pointer;
                        `}
                        onClick={callbacks.revert}
                    />
                </Grid>

                <Grid
                    css={css`
                        margin: 12px 32px;
                    `}
                >
                    <CSVDropzone
                        accept={{ 'application/json': ['.json'] }}
                        fileTypeLabel="Only .JSON files are accepted"
                        label="Select a file to upload"
                        handleFileAdd={onUpload}
                    />
                </Grid>
            </ModalContent>
        </ResponsiveSidebarDialog>
    );
};

export default JSONUploadModal;
